import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Container,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { AppColors } from "../../../../util/AppColors";

import {
  createBathBay,
  deleteBathBay,
  getBathBays,
  updateBathBay,
} from "../../../../redux/reducers/bathBaySlice";

import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomTable from "../../../../components/CustomTable";
import CustomTextField from "../../../../components/CustomTextField";
import TopBar from "../../../../components/TopBar/TopBar";
function BathBays() {
  const dispatch = useDispatch();
  const { bathBays, loading } = useSelector((state) => state.bathBay);

  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [form, setForm] = useState({ name: "" });
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    dispatch(getBathBays());
  }, [dispatch]);

  const handleDrawerClose = () => {
    setOpenDrawer(false);
    setForm({ name: "" });
    setIsEditMode(false);
    setEditId(null);
  };

  const handleCreateOrUpdate = () => {
    const payload = { name: form.name, type: "BathBays" };
    if (isEditMode) {
      dispatch(updateBathBay({ id: editId, ...payload }));
    } else {
      dispatch(createBathBay(payload));
    }
    handleDrawerClose();
  };

  const handleEdit = (row) => {
    setForm({ name: row.name });
    setEditId(row.facilityId);
    setIsEditMode(true);
    setOpenDrawer(true);
  };

  const handleDelete = (row) => {
    setDeleteId(row.facilityId);
    setDelModVisible(true);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteId(null);
  };

  const handleDelConfirm = () => {
    dispatch(deleteBathBay(deleteId));
    handleDelModClose();
  };

  const filteredRows = bathBays.filter((row) =>
    row.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleChangeSwitch = (status, bay) => {
    dispatch(
      updateBathBay({
        ...bay,
        id: bay?.facilityId,
        status,
      })
    ).then((res) => {
      if (res?.payload) dispatch(getBathBays());
    });
  };

  return (
    <Box>
      <TopBar>
        <Container maxWidth="xl">
          <Toolbar variant="regular">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <div className="top-row-cen-con w100Per">
                  <div className="w30Per">
                    <CustomTextField
                      placeholder="Search"
                      name="name"
                      fullWidth
                      handleChange={(e) => setSearch(e.target.value)}
                      value={search}
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>

                  <div className="ml20">
                    <CustomButton
                      text="Create"
                      onClick={() => setOpenDrawer(true)}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Toolbar>
          <Typography className="font-medium fs12 gray28">
            Total BathBays: {filteredRows?.length}
          </Typography>
        </Container>
      </TopBar>

      <CustomTable
        grey
        columns={[
          "sNo",
          "bathBaysName",
          "newStatus",
          "createdBy",
          "createdDate",
          "actions",
        ]}
        datas={filteredRows?.map((row, index) => ({
          sNo: index + 1,
          bathBaysName: row?.name,
          newStatus: (
            <div>
              <div>
                <CustomSwitch
                  value={row?.status}
                  onChange={(e) => handleChangeSwitch(e?.target?.value, row)}
                  greenToRed
                />
              </div>
              <div>{row?.status ? "Active" : "Under Maintenance"}</div>
            </div>
          ),
          createdBy: row?.userName || "-",
          createdDate: new Date(row?.createdDate).toLocaleDateString(),
          actions: (
            <div>
              <IconButton
                color="primary"
                size="small"
                onClick={() => handleEdit(row)}
              >
                <EditIcon />
              </IconButton>
              <IconButton
                color="error"
                size="small"
                onClick={() => handleDelete(row)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          ),
        }))}
      />

      {/* Drawer for Create/Edit */}
      <Drawer anchor="right" open={openDrawer} onClose={handleDrawerClose}>
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {isEditMode ? "Edit BathBays" : "Create BathBays"}
            </Typography>
            <IconButton onClick={handleDrawerClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            label="BathBays Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleCreateOrUpdate}
          >
            {isEditMode ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      {/* Delete Confirmation Modal */}
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default BathBays;
